import { Plus } from 'lucide-react'
import { Button } from '@trafiflow/shared-ui'
import { ViewToggle } from './ViewToggle'
import type { ViewMode } from '../../types'

interface FunnelListHeaderProps {
  totalCount: number
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
  onCreateNew: () => void
}

export function FunnelListHeader({
  totalCount,
  viewMode,
  onViewModeChange,
  onCreateNew,
}: FunnelListHeaderProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold text-tf-text">Funnels</h1>
        <p className="text-tf-text-muted">
          {totalCount} {totalCount === 1 ? 'funnel' : 'funnels'}
        </p>
      </div>

      <div className="flex items-center gap-3">
        <ViewToggle viewMode={viewMode} onChange={onViewModeChange} />
        <Button
          variant="primary"
          className="flex items-center gap-2"
          onClick={onCreateNew}
        >
          <Plus className="w-4 h-4" />
          New Funnel
        </Button>
      </div>
    </div>
  )
}
